import { createSlice } from "@reduxjs/toolkit";
const creditSlice = createSlice({
  name: "credits",
  initialState: { Credits: [], showCreditDetails: false },
  reducers: {
    creditsSuccess: (state, action) => {
      state.Credits = action.payload;
    },
    toggleCreditDetails: (state) => {
      state.showCreditDetails = !state.showCreditDetails;
    },
    clearCredit: (state) => {
      state.Credits = [];
    },
  },
});
export const { clearCredit, creditsSuccess, toggleCreditDetails } =
  creditSlice.actions;
export default creditSlice.reducer;
